module.exports = __webpack_public_path__ + "img/pd-img8.05a05c4d.png";